import React from 'react';
import Button from 'PyzShopUi/scripts/react/common/components/form/Button';
import { useTranslationHook } from 'PyzShopUi/scripts/utils/translationHook';
import MiddlewareEventBus from 'PyzShopUi/scripts/react/common/lib/MiddlewareEventBus';
import { DialogEvent } from 'PyzShopUi/scripts/react/common/events/dialogEvent';

const productLocalStoreAvailabilityShortInfoComponent = props => {
    const { concreteId, data, showLocalStoreAvailability, disabled } = props;
    const { translate } = useTranslationHook();
    const storeAvailability = translate('Store availability', { ns: 'article-detail' });
    const wishList = translate('customer.account.wishlist.available', { ns: 'spryker-core' });
    const outOfStock = translate('Out of stock', { ns: 'availability' });
    const inYourStore = translate('In your store', { ns: 'article-detail' });
    const checkStoreAvailability = translate('Check store availability', { ns: 'article-detail' });

    const openDialog = e => {
        e.preventDefault();
        MiddlewareEventBus.getInstance().publish({ type: DialogEvent.OPEN_DIALOG, payload: { id: '#local-store-availability-dialog' } });
    };

    if (showLocalStoreAvailability) {
        const available = data?.storeAvailability?.quantity ? data?.storeAvailability?.quantity > 0 : false;

        return (
            <>
                <div data-concrete-id={concreteId} className="product-local-store-availability-short-info-wrapper">
                    <div className="button button-leading-icon" onClick={openDialog}>
                        <i className="icon icon-location"></i>
                        <span>{storeAvailability}</span>
                    </div>
                    <div className="local-store-availability-info text-center">
                        { available ?
                            <span className="local-store-availability-state available">{wishList}</span> :
                            <span className="local-store-availability-state not-available">{outOfStock}</span>
                        }
                        &nbsp;{inYourStore}:
                        <div>
                            <a href="#" onClick={openDialog}>{data?.storeDetails?.title}</a>
                            &nbsp;<i className="icon icon-pen" onClick={openDialog}></i>
                        </div>
                    </div>
                </div>
            </>
        );
    }

    return (
        <>
            <div data-concrete-id={concreteId}>
                <Button
                    icon="location"
                    iconPosition="left"
                    additionalClass={`button-bordered button-leading-icon button-teaser ${disabled ? 'disabled' : ''}`}
                    label={checkStoreAvailability}
                    onClick={openDialog}
                    isDisabled={disabled}
                />
            </div>
        </>
    );
};

export default productLocalStoreAvailabilityShortInfoComponent;
